var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-infos"}},[(_vm.show)?_c('b-progress',{attrs:{"max":100,"striped":"","animated":true}},[_c('b-progress-bar',{attrs:{"value":100,"label":_vm.nbtileLoading}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }